/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : legalRequirementsReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import actionType from "../actionTypes";

const initialState = {
  legalStandardDetails: [],
  legalRequirementsDetails: [],
  legalStandardMainDetails: [],
  legalRequirementsMainDetails: [],
  legalRequirementsMainDetailsAll: [],
  legalStandardTableDetails: [],
};

const legalRequirementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_LEGAL_STANDARD_DETAILS:
      return {
        ...state,
        legalStandardDetails: action.payload.error ? [] : action.payload.data,
      };
    case actionType.GET_LEGAL_REQUIREMENTS_DETAILS:
      return {
        ...state,
        legalRequirementsDetails: action.payload.error
          ? []
          : action.payload.data,
      };
    case actionType.GET_LEGAL_STANDARD_MAIN_DETAILS:
      return {
        ...state,
        legalStandardMainDetails: action.payload.error
          ? []
          : action.payload.data,
      };
    case actionType.GET_LEGAL_REQUIREMENTS_MAIN_DETAILS:
      return {
        ...state,
        legalRequirementsMainDetails: action.payload.error
          ? []
          : action.payload.data,
      };
    case actionType.GET_LEGAL_REQUIREMENTS_MAIN_DETAILS_ALL:
      return {
        ...state,
        legalRequirementsMainDetailsAll: action.payload.error
          ? []
          : action.payload.data,
      };
    case actionType.GET_LEGAL_STANDARD_TABLE_DETAILS:
      return {
        ...state,
        legalStandardTableDetails: action.payload.error
          ? []
          : action.payload.data,
      };
    case actionType.ADD_LEGAL_STANDARD_TABLE:
    case actionType.ADD_LEGAL_STANDARD_TABLE_ROW:
    case actionType.ADD_LEGAL_STANDARD_TABLE_COLUMN:
    case actionType.ADD_LEGAL_STANDARD_TABLE_CELLS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };

    default:
      return state;
  }
};

export default legalRequirementsReducer;
